export const SYSTEM_USER_CONTACT_FIELD = {
  PHONE_MOBILE_NO: 'phone_mobile_no',
  MINISTER_ID: 'minister_id',
} as const;

export const USER_PROFILE_FLAG = {
  CAN_EDIT_MINISTER_ID: 'can_edit_minister_id',
} as const;
